<div class="order-info" *ngIf="orderId && locationNo">
    <div class="order-info__inner">

        <shared-header class="order-info__pre" *ngIf="preHeader" [inverted]="preHeaderInverted" [brandAccent]="true"
            [type]="preHeaderType" [marginTop]="preHeaderMarginTop" [marginBottom]="preHeaderMarginBottom">
            {{preHeader}}
        </shared-header>

        <shared-header class="order-info__main" [type]="type" [marginTop]="marginTop" [marginBottom]="marginBottom"
            [inverted]="headerInverted">

            <ng-container *ngIf="isDineInOrderType$ | async">

                <ng-container *ngIf="!(isDineInOrderBuzzerType$ | async)">
                    {{ dineInTableMessages?.pageHeaderTitle[0] | insertVariableToString }} <br />
                    {{ dineInTableMessages?.pageHeaderTitle[1] | insertVariableToString }} <br />
                    {{ dineInTableMessages?.pageHeaderTitle[2] | insertVariableToString}}
                </ng-container>

                <ng-container *ngIf="isDineInOrderBuzzerType$ | async">
                    {{ dineInBuzzerMessages?.pageHeaderTitle[0] | insertVariableToString }} <br />
                    {{ dineInBuzzerMessages?.pageHeaderTitle[1] | insertVariableToString }} <br />
                    {{ dineInBuzzerMessages?.pageHeaderTitle[2] | insertVariableToString}}
                </ng-container>

            </ng-container>

            <ng-container *ngIf="!(isDineInOrderType$ | async) && !(isDineInOrderBuzzerType$ | async)">
                {{ pickupMessages?.pageHeaderTitle[0] | insertVariableToString }} <br />
                {{ pickupMessages?.pageHeaderTitle[1] | insertVariableToString }} <br />
                {{ pickupMessages?.pageHeaderTitle[2] | insertVariableToString }}
            </ng-container>

        </shared-header>

        <shared-emphasis-text class="order-info__ft"
            *ngIf="(isDineInOrderType$ | async) && !(isDineInOrderBuzzerType$ | async)">
            {{ dineInTableMessages?.pageHeaderNote | insertVariableToString }}
        </shared-emphasis-text>

        <shared-emphasis-text class="order-info__ft" *ngIf="(isDineInOrderBuzzerType$ | async)">
            {{ dineInBuzzerMessages?.pageHeaderNote | insertVariableToString }}
        </shared-emphasis-text>

        <shared-emphasis-text class="order-info__ft" *ngIf="!(isDineInOrderType$ | async)">
            {{ pickupMessages?.pageHeaderNote | insertVariableToString }}
        </shared-emphasis-text>

        <p *ngIf="(isDineInOrderType$ | async) === true">
            <shared-btn class="order-info__order-more-btn" feel="secondary" [inverted]="true"
                (onClick)="handleOrderMoreClick($event)">Order more
            </shared-btn>
        </p>
    </div>
</div>
